import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { useClient } from 'jsonapi-react';
import { useTranslation } from 'react-i18next';
import { ExercisesMetricsChartPerformance } from './exercises-metrics-chart-performance';
import { Widget, WidgetBody, WidgetHeader, WidgetTitle } from '@/components/custom/widget';

export function ExercisesMetricsWidgetPerformance(props) {
  const { timeFilterSelected } = props;
  const { t } = useTranslation();
  const client = useClient();
  const [answeringPerformance, setAnsweringPerformance] = useState([]);

  const getAnsweringPerformance = async () => {
    const { data, error } = await client.fetch(`reports/question_books/answer_performance?week=${timeFilterSelected}`);
    if (error) {
      toast.error(t('toast.errorGetMetrics'));
    } else {
      setAnsweringPerformance(data);
    }
  };

  useEffect(() => {
    getAnsweringPerformance();
  }, [timeFilterSelected]);

  return (
    <Widget>
      <WidgetHeader>
        <WidgetTitle>{t('questionBooks.exploitation')}</WidgetTitle>
      </WidgetHeader>

      <WidgetBody>
        <ExercisesMetricsChartPerformance
          color="#442B8C"
          chartData={answeringPerformance}
          valueSuffix={false}
          timeFilterSelected={timeFilterSelected}
        />
      </WidgetBody>
    </Widget>
  );
}
